import React from 'react'

import classNames from 'classnames'

import { homeConfig } from 'routes/Home/homeConfig'
import { useAuth } from 'routes/Menu/domains/auth'

import { Benefits, BenefitType } from '../../Benefits'
import { Cta, useGetCtaProps } from '../../Cta'
import { GetStartedProps } from './GetStartedModels'

import css from './GetStartedStyles.css'

export const GetStarted = ({ isHeroCTA, isSticky, maxHeight, ref }: GetStartedProps) => {
  const { isAuthenticated } = useAuth()
  const { ctaText, ctaUri } = useGetCtaProps()

  const defaultCtaText = homeConfig.CTA.stickyCTA

  const ctaTextDynamic = isSticky && !isHeroCTA && !isAuthenticated ? defaultCtaText : ctaText

  const className = isHeroCTA
    ? css.stickyContainer
    : classNames(css.mobileStickyInitial, css.mobileStickyRemoval, {
        [css.mobileSticky]: isSticky,
        [css.hideShadow]: maxHeight && isSticky,
      })

  return (
    <div
      className={className}
      ref={ref}
      style={maxHeight && !isHeroCTA ? { top: `${maxHeight}px` } : {}}
    >
      <Cta
        ctaUri={ctaUri}
        trackingSectionName={isHeroCTA ? 'hero' : 'stickyCTA'}
        dataTesting={isHeroCTA ? 'homepageHeroCTA' : 'stickyCTA'}
      >
        {ctaTextDynamic}
      </Cta>
      <Benefits pickFilter={[BenefitType.NO_LOCK_IN]} />
    </div>
  )
}
